import React from 'react';
interface DashboardCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}
export function DashboardCard({
  title,
  subtitle,
  children,
  icon,
  className = ''
}: DashboardCardProps) {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-200 p-4 ${className}`} data-id="element-351">
      <div className="mb-4" data-id="element-352">
        <div className="flex items-center" data-id="element-353">
          {icon}
          <h3 className="font-medium text-gray-800" data-id="element-354">{title}</h3>
        </div>
        {subtitle && <div className="text-sm text-gray-500" data-id="element-355">{subtitle}</div>}
      </div>
      {children}
    </div>;
}